import React, { useState, useEffect } from 'react';
import Verifiers from '../../../../../utils/Verifiers.jsx';
import EditarBloque from './EditarBloque';
import TablaCatalogos from './TablaCatalogos';
import BotonOpcion from './BotonOpcion';

const BloquesSeccion = (p) => {
    const show = p.show;
    const data = p.data;
    const datalen = data.length;
    const keys = [//se usa para mostrar los datos en la tabla, key es el nombre del campo y name es como se mostrará al usuario en la tabal el titulo
        { key: 'flor', name: 'FLOR', },
        { key: 'variedad', name: 'VARIEDAD' },
        { key: 'color', name: 'COLOR' },
        { key: 'por_plan', name: 'POR PLAN' }, { key: 'relaciones_vivero', name: 'REL. REG. VIVERO' }, { key: 'relaciones_campo', name: 'REL. REG. CAMPO' }];
    const [resultados, setresultados] = useState([...data]);//lista de elementos qque se muestarn en la interfaz, por defecto son todos los de la lisyta data
    const [filtros, setfiltros] = useState({ asociados_vivero: false, asociados_campo: false, sin_asociacion: false, search_word: "" }); //filtros que se aplican a la lista de resultados
    const [guardado_inicial, setgurdado_inicial] = useState(false);
    const [editar, seteditar] = useState(false);
    const [crear, setcrear] = useState(false);

    //Cuando se intancia por primera vez el componente la lista estará vacía, una vez que lleguen los datos de la aí se agregan los datos
    if (!guardado_inicial) {
        if (datalen > 0 && resultados.length === 0) {
            setgurdado_inicial(true);
            setresultados([...data]);
        } else if (datalen > 0 && resultados.length > 0) setgurdado_inicial(true);
    }

    useEffect(() => {
        aplicarFiltros({ asociados_vivero: false, asociados_campo: false, sin_asociacion: false, search_word: "" });
    }, [show]);

    const aplicarFiltros = (filtross = { ...filtros }, dataa = [...data]) => {
        let len = dataa.length;
        let result = [];
        let buscar = Verifiers.extraerBloquesUnicos(Verifiers.text_normalice(filtross.search_word));
        let activeSearch = buscar.length > 0;
        if (!filtross.asociados_vivero && !filtross.asociados_campo && !activeSearch && !filtross.sin_asociacion) {
            setresultados([...dataa]);
            setfiltros({ ...filtross });
            return;
        }

        for (let i = 0; i < len; i++) {
            if (filtross.sin_asociacion && (+dataa[i].relaciones_campo > 0 || +data[i].relaciones_vivero > 0)) continue;
            if (filtross.asociados_campo && +dataa[i].relaciones_campo === 0) continue;
            if (filtross.asociados_vivero && +dataa[i].relaciones_vivero === 0) continue;
            if (activeSearch) {
                let keySearch = Verifiers.text_normalice(`${dataa[i].por_plan} ${dataa[i].flor} ${dataa[i].variedad} ${dataa[i].color} ${dataa[i].relaciones_vivero} ${dataa[i].relaciones_campo}`);
                if (!Verifiers.elementosEnCadena(keySearch, buscar)) continue;
            }
            result.push(dataa[i]);
        }
        setresultados([...result]);
        setfiltros({ ...filtross });
    }

    const buscar = (event) => {
        let search_word = event.target.value ?? '';
        let fl = { ...filtros, search_word: search_word };
        aplicarFiltros(fl);
    }

    const filtros_existencia = (event) => {
        let name = event.target.name;
        let fl;
        if (name === 'sin_asociacion') fl = { ...filtros, ['asociados_vivero']: false, ['asociados_campo']: false, ['sin_asociacion']: !filtros.sin_asociacion };
        else fl = { ...filtros, [name]: !filtros[name], ['sin_asociacion']: false };
        aplicarFiltros(fl);
    }

    const cerrar = (datosActualizar = false) => {
        if (datosActualizar) {
            p.setdatosFlor(datosActualizar);
            aplicarFiltros(filtros, datosActualizar.tipos_flor);
        }
        seteditar(null);
        setcrear(null);
    }
    const totalAsociados = () => {
        let total = 0;
        for (let i = 0; i < datalen; i++)if (+data[i].relaciones_campo === 0 && +data[i].relaciones_vivero === 0) total++;
        return total;
    }

    return (
        <div className='w-100 h-100 p-2'>
            <div className='row justify-content-evenly w-100 m-0 p-0'>
                <div className='form-group bw-200 p-0 m-0 mt-2 mb-2'>
                    <input type='text' className='form-control form-control-sm border border-warning round-xxl shadow-sm'
                        value={filtros.search_word || ""}
                        onChange={buscar}
                        placeholder='buscar por palabras clave' />
                </div>
                <BotonOpcion name='Asociados a vivero' keyName='asociados_vivero' isSelected={filtros.asociados_vivero} funcion={filtros_existencia} />
                <BotonOpcion name='Asociados a campo' keyName='asociados_campo' isSelected={filtros.asociados_campo} funcion={filtros_existencia} />
                <BotonOpcion name='Sin asociaciones' keyName='sin_asociacion' isSelected={filtros.sin_asociacion} funcion={filtros_existencia} />
                <div className='bw-150 m-0 mt-2 mb-2'>
                    <button className={`w-100 btn btn-sm round-xxl btn-light border-warning border-2 text-bold`}
                        onClick={() => setcrear(true)} >Nuevo bloque</button>
                </div>
                <div className='bw-200 m-0 mt-2 mb-2'>
                    <button className={`w-100 btn btn-sm round-xxl btn-danger border-black bg-red3 text-white border-2 text-bold`}
                        onClick={() => p.elimnarNoAsociados("tipo_flor")} disabled={totalAsociados() === 0}>Eliminar no asociados<span className='text-xs text-300 ms-2'>{totalAsociados()}</span></button>
                </div>
                <div className='w-100 m-0 p-0'></div>
                <TablaCatalogos keys={keys} data={resultados} funcion={(res) => { if (!editar) seteditar(res) }} />


            </div>
            {editar && <EditarBloque data={editar} opciones={p.opciones} close={cerrar} />}
            {crear && <EditarBloque data={null} opciones={p.opciones} close={cerrar} />}
        </div>
    )
}

export default BloquesSeccion;